/* ==========================================================================
   Midwest Ponds 2026 article: reading progress, table of contents from H2s
   (as the original section) with the current section highlighted, "Listen to
   article" (Web Speech API, ported from the original), copy link.
   ========================================================================== */
(function () {
  'use strict';
  var d = document;
  var root = d.querySelector('[data-ivp-article]');
  if (!root) return;
  var content = root.querySelector('[data-ra-article-content]');

  /* ---------- Reading progress ---------- */
  var bar = d.querySelector('[data-ivp-progress]');
  if (bar && content) {
    var raf = null;
    var tick = function () {
      raf = null;
      var r = content.getBoundingClientRect();
      var total = Math.max(1, r.height - window.innerHeight * 0.5);
      bar.style.width = (Math.min(1, Math.max(0, -r.top / total)) * 100).toFixed(1) + '%';
    };
    window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(tick); }, { passive: true });
    tick();
  }

  /* ---------- Table of contents (H2 only, like the original) ---------- */
  var lists = Array.prototype.slice.call(root.querySelectorAll('[data-ra-toc-list]'));
  var empties = Array.prototype.slice.call(root.querySelectorAll('[data-ra-toc-empty]'));
  var headings = content ? Array.prototype.slice.call(content.querySelectorAll('h2')).filter(function (h) { return (h.innerText || '').trim().length; }) : [];
  var slugify = function (s) { return (s || '').toLowerCase().trim().replace(/['"]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); };
  var used = {};
  headings.forEach(function (h) {
    if (!h.id) {
      var base = slugify(h.innerText) || 'section', id = base, n = 2;
      while (used[id] || d.getElementById(id)) id = base + '-' + n++;
      h.id = id;
    }
    used[h.id] = true;
  });
  lists.forEach(function (list) { list.innerHTML = ''; });
  empties.forEach(function (e) { e.hidden = headings.length > 0; });
  var links = [];
  headings.forEach(function (h, i) {
    lists.forEach(function (list) {
      var li = d.createElement('li');
      var a = d.createElement('a');
      a.href = '#' + h.id;
      a.textContent = (h.innerText || '').trim();
      a.setAttribute('data-i', i);
      a.addEventListener('click', function (e) {
        e.preventDefault();
        h.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', '#' + h.id);
        var det = list.closest('details');
        if (det && det.classList.contains('ivp-ra__toc-mobile')) det.open = false;
      });
      li.appendChild(a);
      list.appendChild(li);
      links.push(a);
    });
  });
  // highlight the section being read
  if (headings.length && 'IntersectionObserver' in window) {
    var current = -1;
    var setActive = function (i) {
      if (i === current) return;
      current = i;
      links.forEach(function (a) { a.classList.toggle('is-active', Number(a.getAttribute('data-i')) === i); });
    };
    var io = new IntersectionObserver(function () {
      var idx = 0;
      headings.forEach(function (h, i) { if (h.getBoundingClientRect().top < window.innerHeight * 0.3) idx = i; });
      setActive(idx);
    }, { rootMargin: '0px 0px -60% 0px', threshold: [0, 1] });
    headings.forEach(function (h) { io.observe(h); });
    window.addEventListener('scroll', function () {
      var idx = 0;
      for (var i = 0; i < headings.length; i++) if (headings[i].getBoundingClientRect().top < 140) idx = i;
      setActive(idx);
    }, { passive: true });
  }

  /* ---------- Listen (Web Speech API), as the original section ---------- */
  var ttsBtn = root.querySelector('[data-ra-tts-toggle]');
  if (ttsBtn && content) {
    var labelEl = root.querySelector('[data-ra-tts-label]');
    var noteEl = root.querySelector('[data-ra-tts-note]');
    var supported = 'speechSynthesis' in window && 'SpeechSynthesisUtterance' in window;
    if (!supported) {
      ttsBtn.disabled = true;
      ttsBtn.style.opacity = .55;
      if (labelEl) labelEl.textContent = 'Listen unavailable';
      if (noteEl) noteEl.hidden = false;
    } else {
      var speaking = false, paused = false;
      var stop = function () {
        try { window.speechSynthesis.cancel(); } catch (e) {}
        speaking = false; paused = false;
        ttsBtn.classList.remove('is-playing');
        if (labelEl) labelEl.textContent = 'Listen to article';
      };
      var chunksOf = function (text, max) {
        var out = [], clean = (text || '').replace(/\s+/g, ' ').trim(), i = 0;
        while (i < clean.length) {
          var end = Math.min(i + max, clean.length), slice = clean.slice(i, end);
          var lastStop = Math.max(slice.lastIndexOf('. '), slice.lastIndexOf('! '), slice.lastIndexOf('? ')), lastSpace = slice.lastIndexOf(' ');
          if (end < clean.length && lastStop > 200) end = i + lastStop + 2;
          else if (end < clean.length && lastSpace > 200) end = i + lastSpace + 1;
          out.push(clean.slice(i, end).trim());
          i = end;
        }
        return out.filter(Boolean);
      };
      var speak = function (chunks) {
        speaking = true; paused = false;
        ttsBtn.classList.add('is-playing');
        if (labelEl) labelEl.textContent = 'Pause';
        var idx = 0;
        var next = function () {
          if (!speaking) return;
          if (idx >= chunks.length) { stop(); return; }
          var u = new SpeechSynthesisUtterance(chunks[idx++]);
          u.rate = 1; u.pitch = 1; u.onend = next; u.onerror = stop;
          window.speechSynthesis.speak(u);
        };
        try { window.speechSynthesis.cancel(); } catch (e) {}
        next();
      };
      ttsBtn.addEventListener('click', function () {
        if (!speaking) {
          var title = (root.querySelector('.ivp-ra__title') || {}).innerText || '';
          speak(chunksOf(title + '. ' + (content.innerText || ''), 900));
          return;
        }
        if (!paused) { try { window.speechSynthesis.pause(); } catch (e) {} paused = true; if (labelEl) labelEl.textContent = 'Resume'; }
        else { try { window.speechSynthesis.resume(); } catch (e) {} paused = false; if (labelEl) labelEl.textContent = 'Pause'; }
      });
      window.addEventListener('beforeunload', stop);
      d.addEventListener('visibilitychange', function () { if (d.hidden) stop(); });
    }
  }

  /* ---------- Copy link ---------- */
  var copy = root.querySelector('[data-ra-copy]');
  if (copy) copy.addEventListener('click', function () {
    var url = copy.getAttribute('data-ra-copy');
    var label = copy.querySelector('[data-ra-copy-label]');
    var done = function () { if (label) { label.textContent = 'Copied!'; setTimeout(function () { label.textContent = 'Copy link'; }, 2000); } };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, function () {});
    else { var t = d.createElement('textarea'); t.value = url; d.body.appendChild(t); t.select(); try { d.execCommand('copy'); done(); } catch (e) {} t.remove(); }
  });

  /* ---------- Close the "More AI" menu on outside click ---------- */
  var more = root.querySelector('.ivp-ra__more-ai');
  if (more) d.addEventListener('click', function (e) { if (more.open && !more.contains(e.target)) more.open = false; });
})();
